import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'

export interface OutageNotice {
  enabled: boolean
  message: string
}

export interface ConfigResponse {
  /** Wrks SSO portal (legacy launch / "back to Wrks"), chosen by the backend from APP_SOURCE. */
  loginUrl: string
  /** Wrks OAuth 2.0 login available: the login button goes to oauthStartUrl and the app auto-starts it once. */
  oauthLoginEnabled?: boolean
  /** `/api/auth/oauth/start` rewritten to the API base by transformApiUrls. */
  oauthStartUrl?: string
  freepassEnabled: boolean
  isStaging: boolean
  // gov(NCloud) 배포에서는 콘텐츠/설정 수정 불가, 스테이징 카운터파트도 없음.
  // infra split 미적용 시 백엔드는 contentReadOnly=false, stagingAvailable=true 반환.
  contentReadOnly?: boolean
  stagingAvailable?: boolean
  outageNotice: OutageNotice
}

export function useConfig() {
  return useQuery<ConfigResponse>({
    queryKey: ['config'],
    queryFn: () => api.get<ConfigResponse>('/config'),
    staleTime: 60_000,
    refetchOnWindowFocus: true,
  })
}
